// extracted by mini-css-extract-plugin
export default {"colorPrimaryGrey":"#5C6770","dashboardQuickSearch":"TowuiuaJtkpyloNfSGQA","title":"OKYfrBhnJprT5F3JypDL","hint":"azBCzbC4ZAvAXnggIT2z"};